import { render, staticRenderFns } from "./deliveryTrendChart.vue?vue&type=template&id=32e9b317&"
import script from "./deliveryTrendChart.vue?vue&type=script&lang=js&"
export * from "./deliveryTrendChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports